import { Component, Input, OnChanges, OnInit, EventEmitter, Output } from '@angular/core'

import { FiltroExtrato } from '../shared/filtro-extrato'
import { ExtratoDeRecebimentos } from '../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { Recebimento } from '../../pkw-data/collect/extrato/recebimento.model'
import { Agrupamento } from '../../pkw-data/collect/extrato/agrupamento.model'
import { ExtratoDeRecebimentosService } from './shared/extrato-de-recebimentos.service'
import { Agrupador } from '../../pkw-data/collect/extrato/agrupador.enum'

@Component({
    selector: 'col-extratos-de-recebimentos',
    templateUrl: './extratos-de-recebimentos.component.html',
    styleUrls: ['../extratos.component.scss']
})
export class ExtratosDeRecebimentosComponent implements OnInit, OnChanges {
    @Input() filtro: FiltroExtrato

    @Output() extratoObtido = new EventEmitter<ExtratoDeRecebimentos>()

    extrato: ExtratoDeRecebimentos
    agrupamento: Agrupamento<Recebimento>
    totalRecebido: number
    possuiDados: boolean
    extratoCarregado: boolean
    detalheExpandido: boolean
    agrupador: number
    agrupadorOperadora = Agrupador.Operadora.id
    agrupadorEstabelecimento = Agrupador.Estabelecimento.id  


    constructor(private extratoDeRecebimentosService: ExtratoDeRecebimentosService) {}

    ngOnInit() {
        this.extratoCarregado = false
        this.possuiDados = false
        this.detalheExpandido = false
    }

    ngOnChanges() {
        if (this.filtro) {
            this.agrupador = this.filtro.agrupador
            this.obterExtrato()
        }
    }

    obterExtrato() {
        this.extratoDeRecebimentosService
            .pesquisar(this.filtro.toFilter())
            .subscribe(extratos => {
                this.esconderDatelhe()
                this.extrato = extratos[0]
                this.extratoCarregado = true
                this.possuiDados = this.extrato && this.extrato.agrupamentos.length > 0
                this.totalRecebido = this.calcularTotalRecebido()
                this.extratoObtido.emit(this.extrato)
            })
    }

    exibirDetalhe(agrupamento: Agrupamento<Recebimento>) {
        if (this.agrupamento === agrupamento) {
            this.detalheExpandido = !this.detalheExpandido
        } else {
            this.agrupamento = agrupamento
            this.detalheExpandido = true
        }
    }

    agenteIsValido(agrupamento: Agrupamento<Recebimento>): Boolean {
        const isValido = !!agrupamento.estabelecimento && !!agrupamento.estabelecimento.agente && !!agrupamento.estabelecimento.agente.operadoraDeMaquina;
        return isValido;
    }

    private calcularTotalRecebido() {
        if (!this.possuiDados) {
            return null
        }

        return this.extrato.agrupamentos.reduce((total, agrupamento) => {
            return total + agrupamento.transacao.valorLiquido
        }, 0)
    }

    private esconderDatelhe() {
        this.agrupamento = undefined
        this.detalheExpandido = false
    }
}


// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-recebimentos/extratos-de-recebimentos.component.ts